export default "__VITE_ASSET__CV_CxC5R__"